import { render } from "./SocialProofComponent.vue?vue&type=template&id=a2b38a96&scoped=true"
import script from "./SocialProofComponent.vue?vue&type=script&lang=js"
export * from "./SocialProofComponent.vue?vue&type=script&lang=js"

import "./SocialProofComponent.vue?vue&type=style&index=0&id=a2b38a96&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b38a96"]])

export default __exports__